import type { WithdrawGetRequest, WithdrawGetResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class GetWithdrawUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(body: WithdrawGetRequest): Promise<WithdrawGetResponse> {
    if (!body || typeof body !== 'object') {
      throw new Error('body is required');
    }
    return this.repository.getWithdraw(body);
  }
}


